import * as types from "./actionTypes";

export const importFile = data => {
  return {
    type: types.IMPORT_FILE_TRANSACTIONS_REQUEST,
    data
  };
};
export const importFileSuccess = data => {
  return {
    type: types.IMPORT_FILE_TRANSACTIONS_SUCCESS,
    data: data
  };
};
export const importFileFailure = () => {
  return {
    type: types.IMPORT_FILE_TRANSACTIONS_FAILURE
  };
};

export const createMissingObjectsForImportFile = data => {
  return {
    type: types.CREATE_MISSING_OBJECTS_FOR_IMPORT_TRANSACTIONS_REQUEST,
    data
  };
};
export const createMissingObjectsForImportFileSuccess = data => {
  return {
    type: types.CREATE_MISSING_OBJECTS_FOR_IMPORT_TRANSACTIONS_SUCCESS,
    data: data
  };
};
export const createMissingObjectsForImportFileFailure = () => {
  return {
    type: types.CREATE_MISSING_OBJECTS_FOR_IMPORT_TRANSACTIONS_FAILURE
  };
};

export const getItemsOfImportedFile = data => {
  return {
    type: types.GET_ITEMS_OF_IMPORTED_TRANSACTIONS_REQUEST,
    data
  };
};
export const getItemsOfImportedFileSuccess = data => {
  return {
    type: types.GET_ITEMS_OF_IMPORTED_TRANSACTIONS_SUCCESS,
    data: data
  };
};
export const getItemsOfImportedFileFailure = error => {
  return {
    type: types.GET_ITEMS_OF_IMPORTED_TRANSACTIONS_FAILURE,
    error: error
  };
};

export const storeItemsOfImportedFile = data => {
  return {
    type: types.STORE_ITEMS_OF_IMPORTED_TRANSACTIONS_REQUEST,
    data
  };
};
export const storeItemsOfImportedFileSuccess = data => {
  return {
    type: types.STORE_ITEMS_OF_IMPORTED_TRANSACTIONS_SUCCESS,
    data: data
  };
};
export const storeItemsOfImportedFileFailure = () => {
  return {
    type: types.STORE_ITEMS_OF_IMPORTED_TRANSACTIONS_FAILURE
  };
};
